// extracted by mini-css-extract-plugin
export default {"container":"StockAdmin_container__gCNRr","productsGrid":"StockAdmin_productsGrid__WGB30","productCard":"StockAdmin_productCard__8t1zD"};